import { IUser } from '@/services/auth/types';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import {
  FilterState,
  ProductAttributeFilterState,
  showBackButtonInNavbarState,
  showSettingTabPanel,
  TagState,
} from './types';

interface AuthState {
  user: IUser | null;
  setUser: (user: IUser) => void;
  clearUser: () => void;
}
interface ChatState {
  showChatOverlay: boolean;
  toggleChatOverlay: () => void;
  setShowChatOverlay: (value: boolean) => void;
}

export const useStore = create<AuthState & ChatState>()(
  persist(
    (set) => ({
      user: null,
      setUser: (user: IUser) => set({ user }),
      clearUser: () => set({ user: null }),
      // Chat State
      showChatOverlay: false,
      toggleChatOverlay: () => set((state) => ({ showChatOverlay: !state.showChatOverlay })),
      setShowChatOverlay: (value) => set(() => ({ showChatOverlay: value })),
    }),
    {
      name: 'vendor-auth-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

interface LoggedInState {
  isLoggedIn: boolean; // Tracks logged-in state
  toggleLoggedIn: () => void; // Action to toggle the state
}

export const useAuthStore = create<LoggedInState>((set) => ({
  isLoggedIn: false, // Initial state
  // Action to toggle the logged-in state
  toggleLoggedIn: () => set((state) => ({ isLoggedIn: !state.isLoggedIn })),
}));

export const useFilterStore = create<FilterState>((set) => ({
  searchParamsGlobal: '',
  setSearchParamsGlobal: (params) =>
    set(() => ({
      searchParamsGlobal: params,
    })),
}));

// to store tags to show in filters
export const useTagStore = create<TagState>((set) => ({
  tag: [],
  setTag: (params) =>
    set(() => ({
      tag: params,
    })),
}));

export const useProductAttributeFilterStore = create<ProductAttributeFilterState>((set) => ({
  productAttributeFilterState: '',
  setProductAttributeFilterState: (params) =>
    set(() => ({
      productAttributeFilterState: params,
    })),
}));

export const useShowBackButtonInNavbar = create<showBackButtonInNavbarState>()(
  persist(
    (set) => ({
      showBackButtonInNavbarState: false,
      setShowBackButtonInNavbarState: (params: boolean) =>
        set(() => ({
          showBackButtonInNavbarState: params,
        })),
    }),
    {
      name: 'back-button-back-icon',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export const useShowSettingTabPanel = create<showSettingTabPanel>()(
  persist(
    (set) => ({
      showSettingTabPanel: false,
      setShowSettingTabPanel: (params: boolean) =>
        set(() => ({
          showSettingTabPanel: params,
        })),
    }),
    {
      name: 'setting-tab-panel-in-mobile-screen',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

// Define the type for the store
interface CouponStore {
  coupon: string;
  setCoupon: (coupon: string) => void;
}

export const useCoupon = create<CouponStore>()(
  persist(
    (set) => ({
      coupon: '',
      setCoupon: (coupon: string) => set({ coupon }),
    }),
    {
      name: 'coupon-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
